<!--单文章-->
<template>
    <div>
        <el-row style="text-align: end;margin-bottom: 22px;">
            <!--icon="el-icon-plus" -->
            <el-button v-if="showAdd" type="primary" @click="showAddDialog">添加内容</el-button>
            <el-button v-else-if="!showAdd" type="primary" @click="showEditDialog">编辑内容</el-button>
        </el-row>
        <el-card shadow="hover" class="el-card">
            <div v-html="editItem.content"></div>
        </el-card>
        <el-dialog :title="titleForm"
                   width="50%"
                   @close="handleClose"
                   :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="100px">
                <tinymce v-model="editItem.content" @onClick="editFun"/>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import Tinymce from '@/components/tinymce/Tinymce'
import {addArticlesSingle, articlesSingle, updateArticlesSingle} from '@/api/file'
export default {
    name: '',
    components: {
        Tinymce
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        type: {
            default: ''
        }
    },
    data() {
        return {
            showAdd: true,
            titleForm: '添加',
            editDialogVisible: false,
            editItem:{
                content: '',
                type: this.type,
                title: this.title
            },
            formRules:{
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        handleClose() {
            this.editDialogVisible = false
        },
        showAddDialog(){
            this.titleForm = '添加'
            this.editDialogVisible = true
        },
        showEditDialog(){
            this.titleForm = '编辑'
            this.editDialogVisible = true
        },
        editFun(content) {
            this.editItem.content = content
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                if(this.titleForm==='添加'){
                    addArticlesSingle(this.editItem).then(response => {
                        if(response.code!=200){
                            return this.$message.error(this.titleForm+'失败！')
                        }
                        this.$message.success(this.titleForm+'成功！')
                        this.editDialogVisible = false
                        this.getArticlesPage()
                    })
                }else if(this.titleForm==='编辑'){
                    updateArticlesSingle(this.editItem).then(response => {
                        // console.log('编辑结果',response.data)
                        if(response.code!=200){
                            return this.$message.error(this.titleForm+'失败！')
                        }
                        this.$message.success(this.titleForm+'成功！')
                        this.editDialogVisible = false
                        this.getArticlesPage()
                    })
                }
            })
        },
        getArticlesPage(){
            articlesSingle(this.type).then(response=>{
                if(response.code!=200)
                    return this.$message.error('获取'+ this.title+'失败！')
                console.log('获取'+ this.title,response)
                if(response.data!=undefined){
                    this.editItem = response.data
                    this.showAdd=false
                }else{
                    this.showAdd=true
                }
            })
        }
    },
    created() {
        this.getArticlesPage()
    }
}
</script>

<style scoped>

</style>
